import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { INavbarTabContent } from './navbar-tab-content.types';
import {
  NX23Link,
  NX23NavbarDropdown,
} from 'src/app/shared/types/content-types';
import { PlatformService } from 'src/app/shared/services/platform.service';
import { ChatbotService } from 'src/app/shared/services/chatbot.service';

@Component({
  selector: 'nx-navbar-tab-content',
  templateUrl: './navbar-tab-content.component.html',
  styleUrls: ['./navbar-tab-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarTabContentComponent implements INavbarTabContent, OnInit {
  constructor(
    private chatbot: ChatbotService,
    private platform: PlatformService,
  ) {}

  // INPUTS
  @Input() data!: INavbarTabContent['data'];
  @Input() tabContent!: INavbarTabContent['tabContent'];

  // OTUPUT
  @Output()
  isDropdownActiveChange: INavbarTabContent['isDropdownActiveChange'] =
    new EventEmitter();

  // PROPERTIES
  isDropdownActive: boolean = false;
  homeHref!: string;

  // HANDLERS
  showChatbot(): void {
    this.chatbot.show();
  }

  passDropdownActiveValue(isDropdownActive: boolean): void {
    this.isDropdownActiveChange.emit(isDropdownActive);
  }

  isLink(item: any): item is NX23Link {
    return item.fields.dropdownContent === undefined;
  }

  isDropdown(item: any): item is NX23NavbarDropdown {
    return item.fields.dropdownContent !== undefined;
  }

  // HOOKS
  ngOnInit(): void {
    this.homeHref = this.platform.getAbsoluteURL('/');
  }
}
